import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import Timer from 'react-compound-timer'
import { Formik, FormikHelpers } from 'formik'
import * as Yup from 'yup'
import * as QueryString from 'query-string'
import { useTranslation } from 'react-i18next'
import Footer from './Footer'
import { background03, cscfLogo, resetIcon } from '../common/images'
import { AppLogger } from '../../AppLogger'
import { postChangePassword } from './utils'
import ScreenLoader from '../ScreenLoader'

const logger = AppLogger.getInstance()
const lowercaseRegex = /(?=.*[a-z])/
const uppercaseRegex = /(?=.*[A-Z])/
const numericRegex = /(?=.*[0-9])/

enum EStatus {
    Start = 'Start',
    Failed = 'Failed',
    Success = 'Sucess',
}
interface IChangePassword {
    email: string
    resetToken: string
    password: string
    passwordConfirmation: string
    targetApp: string
}
interface IReqChangePass {
    status: EStatus
    processing: boolean
}

const ChangePass = (props: any) => {
    const { t } = useTranslation(['Login', 'Validations', 'Error'])
    const params = QueryString.parse(props.location.search)
    let validationSchema = Yup.object().shape({
        email: Yup.string()
            .email(t('Validations:invalidEmail'))
            .required(t('Validations:required')),
        targetApp: Yup.string()
            .required(t('Validations:required'))
            .oneOf(['IF', 'WF']),
        password: Yup.string()
            .matches(lowercaseRegex, 'one lowercase required!')
            .matches(uppercaseRegex, 'one uppercase required!')
            .matches(numericRegex, 'one number required!')
            .required(t('Validations:required'))
            .min(6, t('Validations:passwordLength')),
        passwordConfirmation: Yup.string()
            .required(t('Validations:required'))
            .oneOf([Yup.ref('password')], t('Validations:passwordMatch')),
    })
    const [redirect, setRedirect] = useState<boolean>(false)
    const [request, setRequest] = useState<IReqChangePass>({
        status: EStatus.Start,
        processing: false,
    })

    let email = ''
    let resetToken = ''
    let targetApp = ''
    if (params.email && params.resetToken) {
        email = params.email as string
        resetToken = params.resetToken as string
        targetApp = params.targetApp as string
    } else {
        email = props.history.location.state.email
        resetToken = props.history.location.state.resetToken
        targetApp = props.history.location.state.targetApp
    }
    let data0 = {
        email,
        resetToken,
        password: '',
        passwordConfirmation: '',
        targetApp,
    }
    const getTimer = (seconds: number): JSX.Element => {
        return (
            <Timer
                initialTime={seconds}
                direction="backward"
                checkpoints={[
                    {
                        time: 1000,
                        callback: () => setRedirect(true),
                    },
                ]}
            >
                {() => (
                    <React.Fragment>
                        <Timer.Seconds />
                    </React.Fragment>
                )}
            </Timer>
        )
    }
    const handleChangePassword = async (
        resetData: IChangePassword
    ): Promise<void> => {
        try {
            setRequest({ status: EStatus.Start, processing: true })
            const {
                email,
                resetToken,
                password,
                passwordConfirmation,
                targetApp,
            } = resetData

            await postChangePassword(
                email,
                resetToken,
                password,
                passwordConfirmation,
                targetApp
            )
            setRequest({ status: EStatus.Success, processing: false })
        } catch (e) {
            setRequest({ status: EStatus.Failed, processing: false })
            logger.error(e)
        }
    }

    const renderServerMsg = (): JSX.Element => {
        switch (request.status) {
            case EStatus.Success:
                return (
                    <p className="success-message" style={{ color: '#195190' }}>
                        {t('successChangePassword')}.<br />
                        {t('Error:redirect')}
                        <span>
                            &nbsp;
                            <b>{getTimer(8000)}</b>
                            &nbsp;
                        </span>
                        {t('Error:seconds')}
                    </p>
                )
            case EStatus.Failed:
                return (
                    <p className="error-message">{t('errorChangePassword')}</p>
                )
            default:
                return <p />
        }
    }
    return (
        <div className="wrapper">
            <div className="main-background" style={{ background: '#f3f3f3' }}>
                <img src={background03} alt="" />
            </div>
            <div className="dashboard-login">
                <div className="login-form block-shadow">
                    <Formik
                        initialValues={{ ...data0 }}
                        validationSchema={validationSchema}
                        onSubmit={(
                            values,
                            actions: FormikHelpers<IChangePassword>
                        ) => {
                            logger.log({ values, actions })
                            actions.setSubmitting(false)
                            handleChangePassword(values)
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                        }) => (
                            <div className="block-white">
                                <div className="aiec-icon">
                                    <img src={cscfLogo} alt="" />
                                </div>
                                <h1>
                                    <strong>
                                        {t('Login:requestResetPassword')}
                                    </strong>
                                </h1>

                                <div className="form-group">
                                    {renderServerMsg()}
                                </div>

                                <br />
                                <div className="form-group block-disabled">
                                    <label htmlFor="siteName">
                                        {t('Login:targetApplication')}
                                    </label>
                                    <div
                                        className="options"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'start',
                                        }}
                                    >
                                        <label className="option circle-radio">
                                            <div className="option-content">
                                                <p>Info fauna</p>
                                            </div>
                                            <input
                                                name="targetApp"
                                                type="radio"
                                                id="targetApp"
                                                onChange={handleChange}
                                                value="IF"
                                                checked={
                                                    values.targetApp === 'IF'
                                                }
                                                disabled
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                        &nbsp;
                                        <label className="option circle-radio">
                                            <div className="option-content">
                                                <p>Webfauna</p>
                                            </div>
                                            <input
                                                name="targetApp"
                                                type="radio"
                                                id="targetApp"
                                                onChange={handleChange}
                                                value="WF"
                                                checked={
                                                    values.targetApp === 'WF'
                                                }
                                                disabled
                                            />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    {errors && (
                                        <p className="error-message">
                                            {errors.targetApp}
                                        </p>
                                    )}
                                </div>
                                <br />

                                <div className="form-group">
                                    <label htmlFor="siteName">
                                        {t('Login:email')}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="email"
                                        id="email"
                                        value={values.email}
                                        placeholder={t('email')}
                                        readOnly
                                        required
                                    />
                                </div>
                                <div
                                    className={`form-group ${
                                        touched.password && errors.password
                                            ? 'required'
                                            : ''
                                    } `}
                                >
                                    <label htmlFor="siteName">
                                        {t('Login:password')}*
                                    </label>
                                    <input
                                        type="password"
                                        name="password"
                                        className="form-control"
                                        id="password"
                                        value={values.password}
                                        placeholder={t('Login:password')}
                                        autoComplete="current-password"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {touched.password && errors.password && (
                                        <p className="error-message">
                                            {errors.password}
                                        </p>
                                    )}
                                </div>
                                <div
                                    className={`form-group ${
                                        touched.passwordConfirmation &&
                                        errors.passwordConfirmation
                                            ? 'required'
                                            : ''
                                    }`}
                                >
                                    <label htmlFor="siteName">
                                        {t('Login:passwordConfirmation')}*
                                    </label>
                                    <input
                                        type="password"
                                        name="passwordConfirmation"
                                        className="form-control"
                                        id="passwordConfirmation"
                                        value={values.passwordConfirmation}
                                        placeholder={t(
                                            'Login:passwordConfirmation'
                                        )}
                                        autoComplete="current-password"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {touched.passwordConfirmation &&
                                        errors.passwordConfirmation && (
                                            <p className="error-message">
                                                {errors.passwordConfirmation}
                                            </p>
                                        )}
                                </div>

                                <div className="form-group">&nbsp;</div>

                                <button
                                    className="btn-login"
                                    onClick={() => handleSubmit()}
                                >
                                    <img src={resetIcon} alt="Connecter" />
                                    {t('reqBtn')}
                                </button>
                            </div>
                        )}
                    </Formik>
                </div>
            </div>
            <Footer />
            {redirect && <Redirect to="/"></Redirect>}
            {request.processing && <ScreenLoader />}
        </div>
    )
}

export default ChangePass
